const REDIR_BASE = "https://mydata.tablemate.net/redir.php?url=";
const DAY_END_API = "tablemate/endpoints/bill/dayEndAuditBESA.php";

function buildUrl(tenantServerUrl, query) {
  const base = `${REDIR_BASE}${tenantServerUrl}/${DAY_END_API}`;
  if (!query) return base;
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

async function parseJsonResponse(res) {
  if (!res.ok) {
    const bodyText = await res.text().catch(() => "<no body>");
    let message = `HTTP ${res.status} ${res.statusText}`;
    try {
      const parsed = JSON.parse(bodyText);
      if (parsed?.error) message = parsed.error;
      else message = `${message} – ${bodyText}`;
    } catch {
      message = `${message} – ${bodyText}`;
    }
    const err = new Error(message);
    err.status = res.status;
    try {
      err.body = JSON.parse(bodyText);
    } catch {
      err.body = null;
    }
    throw err;
  }
  return res.json();
}

export async function fetchDayEndReport({
  tenantServerUrl,
  accessToken,
  restaurantId,
  businessDate,
  startingFloat,
  paidOuts,
  declaredCash,
}) {
  const url = buildUrl(tenantServerUrl, {
    action: "report",
    id: restaurantId,
    date: businessDate,
    startingFloat,
    paidOuts,
    declaredCash:
      declaredCash === "" || declaredCash === null || declaredCash === undefined
        ? undefined
        : declaredCash,
  });

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
    },
  });
  return parseJsonResponse(res);
}

export async function fetchDayEndCloses({
  tenantServerUrl,
  accessToken,
  restaurantId,
  from,
  to,
  limit = 90,
}) {
  const url = buildUrl(tenantServerUrl, {
    action: "closes",
    id: restaurantId,
    from,
    to,
    limit,
  });

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
    },
  });
  return parseJsonResponse(res);
}

export async function finalizeDayEndClose({
  tenantServerUrl,
  accessToken,
  restaurantId,
  payload,
}) {
  const url = buildUrl(tenantServerUrl, { id: restaurantId });
  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(res);
}
